<script>
    import {push} from 'svelte-spa-router'
    import {toUrlEncoded} from './util/urlUtil'
    import {
        emailValidator,
        requiredValidator,
        minimumAmountValidator,
        onePerThreeValidator
    } from './validation/validators.js'
    import {createFieldValidator} from './validation/validation.js'
    import {createCalculator} from './calculation/calculation'
    import {deriveCalculators, getUnitPrice} from './calculation/calculateService'
    import {
        handRub500mlStrategy,
        handRub1000mlStrategy,
        pumpStrategy,
        displayStrategy,
        maskStrategy
    } from './calculation/priceStrategies'

    let companyName, vatNumber, street, streetNumber, box, postalCode, city, contactName, email, tel = null;
    let numberOfHandRubs1000Ml, numberOfHandRubs500Ml, numberOfMasks, numberOfPumps, numberOfDisplays = null;
    let validationErrors = false;
    let formSubmitError = false;

    /* Validation */
    const [companyNameValidity, companyNameValidate] = createFieldValidator(requiredValidator());
    const [vatValidity, vatValidate] = createFieldValidator(requiredValidator());
    const [streetValidity, streetValidate] = createFieldValidator(requiredValidator());
    const [streetNumberValidity, streetNumberValidate] = createFieldValidator(requiredValidator());
    const [postalCodeValidity, postalCodeValidate] = createFieldValidator(requiredValidator());
    const [cityValidity, cityValidate] = createFieldValidator(requiredValidator());
    const [contactNameValidity, contactNameValidate] = createFieldValidator(requiredValidator());
    const [emailValidity, emailValidate] = createFieldValidator(requiredValidator(), emailValidator());
    const [telValidity, telValidate] = createFieldValidator(requiredValidator());
    const [totalValidity, totalValidate] = createFieldValidator(minimumAmountValidator(250));
    const [pumpValidity, pumpValidate] = createFieldValidator(onePerThreeValidator(numberOfHandRubs1000Ml));
    /* End validation */

    /* Calculation */
    const [handRub500mlStore, handRub500mlCalculate] = createCalculator(handRub500mlStrategy, 12);
    const [handRub1000mlStore, handRub1000mlCalculate] = createCalculator(handRub1000mlStrategy, 6);
    const [pumpStore, pumpCalculate] = createCalculator(pumpStrategy, 1);
    const [displayStore, displayCalculate] = createCalculator(displayStrategy, 1);
    const [maskStore, maskCalculate] = createCalculator(maskStrategy, 50);
    let total = deriveCalculators(handRub500mlStore, handRub1000mlStore, pumpStore, displayStore, maskStore);

    /* End calculation */


    async function submitForm(event) {
        event.preventDefault();
        if (hasNoValidationErrors()) {
            startSpinning();
            document.getElementsByClassName("submit")[0].disabled = true;
            validationErrors = false;
            formSubmitError = false;

            await fetch("https://safe-at-work-api.ritenoar.be/saw-submit", {
                method: "POST",
                body: toUrlEncoded(createFormData()),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }).then(r => r.json())
                    .then(data => {
                        stopSpinning();
                        document.getElementsByClassName("submit")[0].disabled = false;
                        push("/submit");
                    }).catch((error) => {
                        stopSpinning();
                        document.getElementsByClassName("submit")[0].disabled = false;
                        formSubmitError = true;
                        console.error('Error:', error);
                    });
        } else {
            validationErrors = true;
        }
    }

    function hasNoValidationErrors() {
        return $companyNameValidity.valid && $vatValidity.valid && $streetValidity.valid && $streetNumberValidity.valid
                && $postalCodeValidity.valid && $cityValidity.valid && $contactNameValidity.valid
                && $emailValidity.valid && $telValidity.valid && $totalValidity.valid && $pumpValidity.valid;
    }

    function createFormData() {
        let data = {
            companyName: companyName,
            vatNumber: vatNumber,
            street: street,
            streetNumber: streetNumber,
            postalCode: postalCode,
            city: city,
            contactName: contactName,
            email: email,
            phoneNumber: tel
        };
        if (box) data.box = box;
        if (numberOfHandRubs500Ml) data.numberOfHandRubs500Ml = numberOfHandRubs500Ml;
        if (numberOfHandRubs1000Ml) data.numberOfHandRubs1000Ml = numberOfHandRubs1000Ml;
        if (numberOfMasks) data.numberOfMasks = numberOfMasks;
        if (numberOfPumps) data.numberOfPumps = numberOfPumps;
        if (numberOfDisplays) data.numberOfDisplays = numberOfDisplays;

        return data;
    }

    function startSpinning() {
        showByClass("btn-spinner");
        hideByClass("btn-text");
    }

    function stopSpinning() {
        hideByClass("btn-spinner");
        showByClass("btn-text");
    }

    function showByClass(className) {
        let classList = document.getElementsByClassName(className)[0].classList;
        classList.add("show");
        classList.remove("hide");
    }


    function hideByClass(className) {
        let classList = document.getElementsByClassName(className)[0].classList;
        classList.add("hide");
        classList.remove("show");
    }

</script>

<style>
    .lds-dual-ring.hide {
        display: none;
    }

    .hide {
        display: none;
    }

    .show {
        display: block;
    }

    section {
        padding: 5px;
    }

    .section-more {
        padding-top: 10px;
    }

    section div {
        margin-bottom: 10px;
    }

    .spacer {
        margin-top: 25px;
    }

    button {
        background-color: #032f62;
        width: 200px;
    }

    button:hover {
        background-color: #063f81;
    }

    .field.has-addons > .control.is-danger {
        margin-right: 0px;
    }

    .columns,
    .column {
        margin-bottom: 0
    }

    .all-images {
        position: absolute;
        right: 0;
        max-width: 40%;
        margin-right: 50px;
    }

    .control .button[disabled] {
        pointer-events: none;
    }

    .button.price {
        min-width: 100px;
        font-size: 0.75em;
        height: 100%;
    }

    .notification a.notification-anchor {
        color: #032f62;
    }

    @media (max-width: 768px) {
        .all-images {
            display: none !important;
        }

        input.mobile-small {
            min-width: 75px;
            max-width: 75px;
        }

        .button.is-static {
            font-size: 0.75em;
            height: 100%;
        }

    }

    /* Spinner */
    .lds-dual-ring {
        display: inline-block;
        width: 40px;
        height: 40px;
    }

    .lds-dual-ring:after {
        content: " ";
        display: block;
        width: 32px;
        height: 32px;
        margin: 8px;
        border-radius: 50%;
        border: 4px solid #fff;
        border-color: #fff transparent #fff transparent;
        animation: lds-dual-ring 1.2s linear infinite;
    }

    @keyframes lds-dual-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }


</style>

<section class="section">
    <div>
        <p>W-Pharma en Smidt-Imex willen hun bijdrage leveren in de strijd tegen de verdere verspreiding van het
            Coronavirus COVID-19. Beide bedrijven slaan de handen in elkaar om bedrijven te voorzien in
            <strong>kwalitatief</strong> safe-at-work materiaal aan <strong>prijzen onder het marktgemiddelde</strong>.
        </p>
    </div>

    <div>
        <p><strong>W-Pharma</strong> heeft als maatwerkbedrijf de noodzakelijke toelating van FOD volksgezondheid en
            leefmilieu, cel Biociden binnen het Directoraat-generaal Leefmilieu gekregen om tijdelijk handrub (een
            ontsmettende hydroalcoholische oplossing voor de handen) te produceren. De productie gebeurt met
            inachtneming van de hoogste veiligheidsnormen, zowel op gebied van beschermende maatregelen naar hun
            werknemers tegen besmetting met COVID-19 virus als op vlak van brandveiligheid (ATEX).</p>
    </div>

    <div>
        <p><strong>Smidt-Imex</strong> staat als service partner van W-Pharma in voor de bevoorrading en levering van de
            W-Pharma handrubs en biedt bijkomend ook pompjes, displays en chirurgische mondmaskers type IIR aan.</p>
    </div>
</section>

<section class="section section-more">
    <div>
        <p>Uw bedrijf safe-at-work maken? Bestel hier:</p>
    </div>

    <div class="notification is-light">
        <p>
            <span class="icon is-small is-left">
                <span class="mdi mdi-information-outline"></span>
            </span>
            De prijs per stuk gaat omlaag naarmate u grotere aantallen bestelt. U kan de de volledige prijsbepaling bij de <a class="notification-anchor" href="#/documents">documenten</a> bekijken.
        </p>
    </div>
</section>

{#if validationErrors}
    <div class="notification is-danger is-light">
        Het formulier is niet correct ingevuld. Gelieve alle verplichte velden in te vullen.
    </div>
{/if}

{#if formSubmitError}
    <div class="notification is-danger is-light">
        Het formulier is niet correct verzonden. Gelieve opnieuw te proberen of ons te contacteren op <a
            href="mailto:safe-at-work@smidt-imex.com">safe-at-work@smidt-imex.com</a>.
    </div>
{/if}

<form>
    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label">Bedrijfsgegevens</label>
        </div>
        <div class="field-body">
            <div class="field">
                <p class="control is-expanded has-icons-left">
                    <input class="input"
                           type="text"
                           placeholder="Bedrijfsnaam"
                           bind:value={companyName}
                           class:is-danger={!$companyNameValidity.valid && $companyNameValidity.dirty}
                           use:companyNameValidate={companyName}>
                    <span class="icon is-small is-left">
                        <span class="mdi mdi-domain"></span>
                    </span>
                </p>
            </div>
            <div class="field">
                <p class="control is-expanded has-icons-left">
                    <input class="input"
                           type="text"
                           placeholder="Ondernemingsnummer"
                           bind:value={vatNumber}
                           class:is-danger={!$vatValidity.valid && $vatValidity.dirty}
                           use:vatValidate={vatNumber}>
                    <span class="icon is-small is-left">
                        <span class="mdi mdi-briefcase"></span>
                    </span>
                </p>
            </div>
        </div>
    </div>

    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label"></label>
        </div>
        <div class="field-body">
            <div class="field has-addons">
                <p class="control is-expanded has-icons-left">
                    <input class="input"
                           type="text"
                           placeholder="Straat"
                           bind:value={street}
                           class:is-danger={!$streetValidity.valid && $streetValidity.dirty}
                           use:streetValidate={street}>
                    <span class="icon is-small is-left">
                        <span class="mdi mdi-map-marker"></span>
                    </span>
                </p>
                <p class="control">
                    <input class="input"
                           type="text"
                           placeholder="Nummer"
                           bind:value={streetNumber}
                           class:is-danger={!$streetNumberValidity.valid && $streetNumberValidity.dirty}
                           use:streetNumberValidate={streetNumber}>
                </p>
                <p class="control">
                    <input class="input"
                           type="text"
                           placeholder="Bus"
                           bind:value={box}>
                </p>
            </div>
        </div>
    </div>

    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label"></label>
        </div>
        <div class="field-body">
            <div class="field has-addons">
                <p class="control has-icons-left">
                    <input class="input"
                           type="text"
                           placeholder="Postcode"
                           bind:value={postalCode}
                           class:is-danger={!$postalCodeValidity.valid && $postalCodeValidity.dirty}
                           use:postalCodeValidate={postalCode}>
                    <span class="icon is-small is-left">
                        <span class="mdi mdi-map-marker"></span>
                    </span>
                </p>
                <p class="control">
                    <input class="input"
                           type="text"
                           placeholder="Gemeente"
                           bind:value={city}
                           class:is-danger={!$cityValidity.valid && $cityValidity.dirty}
                           use:cityValidate={city}>
                </p>
            </div>
        </div>
    </div>

    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label">Contactgegevens</label>
        </div>
        <div class="field-body">
            <div class="field">
                <p class="control is-expanded has-icons-left">
                    <input class="input"
                           type="text"
                           placeholder="Naam"
                           bind:value={contactName}
                           class:is-danger={!$contactNameValidity.valid && $contactNameValidity.dirty}
                           use:contactNameValidate={contactName}>
                    <span class="icon is-small is-left">
                        <span class="mdi mdi-account"></span>
                    </span>
                </p>
            </div>
            <div class="field">
                <p class="control is-expanded has-icons-left">
                    <input class="input"
                           type="email"
                           placeholder="E-mailadres"
                           bind:value={email}
                           class:is-danger={!$emailValidity.valid && $emailValidity.dirty}
                           use:emailValidate={email}>
                    <span class="icon is-small is-left">
                        <span class="mdi mdi-email"></span>
                    </span>
                </p>
            </div>
            <div class="field">
                <p class="control is-expanded has-icons-left">
                    <input class="input"
                           type="tel"
                           placeholder="Telefoonnummer"
                           bind:value={tel}
                           class:is-danger={!$telValidity.valid && $telValidity.dirty}
                           use:telValidate={tel}>
                    <span class="icon is-small is-left">
                        <span class="mdi mdi-phone"></span>
                    </span>
                </p>
            </div>
        </div>
    </div>

    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label">Bestelling</label>
        </div>
        <div class="field-body">
            <div class="field has-addons">
                <p class="control">
                    <span class="button price" disabled="disabled">€{getUnitPrice($handRub500mlStore)}/stuk</span>
                </p>
                <p class="control">
                    <input class="input mobile-small"
                           type="number"
                           placeholder="Aantal"
                           bind:value={numberOfHandRubs500Ml}
                           use:handRub500mlCalculate={numberOfHandRubs500Ml}>
                </p>
                <p class="control">
                    <span class="button is-static">
                        12x handrub 0,5 liter
                    </span>
                </p>
            </div>
        </div>
        <img class="all-images" alt="alle producten samen" src="images/all-together.png"/>
    </div>

    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label"></label>
        </div>
        <div class="field-body">
            <div class="field has-addons">
                <p class="control">
                    <span class="button price" disabled="disabled">€{getUnitPrice($handRub1000mlStore)}/stuk</span>
                </p>
                <p class="control">
                    <input class="input mobile-small"
                           type="number"
                           placeholder="Aantal"
                           bind:value={numberOfHandRubs1000Ml}
                           use:handRub1000mlCalculate={numberOfHandRubs1000Ml}>
                </p>
                <p class="control">
                    <span class="button is-static">
                        6x handrub 1 liter
                    </span>
                </p>
            </div>
        </div>
    </div>

    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label"></label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="field has-addons">
                    <p class="control">
                        <span class="button price" disabled="disabled">€{getUnitPrice($pumpStore)}/stuk</span>
                    </p>
                    <p class="control" class:is-danger={!$pumpValidity.valid && $pumpValidity.dirty}>
                        <input class="input mobile-small"
                               type="number"
                               placeholder="Aantal"
                               bind:value={numberOfPumps}
                               use:pumpCalculate={numberOfPumps}
                               use:pumpValidate={{value: numberOfPumps, otherValue: numberOfHandRubs1000Ml}}
                               class:is-danger={!$pumpValidity.valid && $pumpValidity.dirty}>
                    </p>
                    <p class="control">
                        <span class="button is-static">
                            Pompje voor handrub 1 liter
                        </span>
                    </p>
                </div>
                <p class="help" class:is-danger={!$pumpValidity.valid && $pumpValidity.dirty}>Max. 1 per 3 flessen</p>
            </div>
        </div>
    </div>

    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label"></label>
        </div>
        <div class="field-body">
            <div class="field has-addons">
                <p class="control">
                    <span class="button price" disabled="disabled">€{getUnitPrice($displayStore)}/stuk</span>
                </p>
                <p class="control">
                    <input class="input mobile-small"
                           type="number"
                           placeholder="Aantal"
                           bind:value={numberOfDisplays}
                           use:displayCalculate={numberOfDisplays}>
                </p>
                <p class="control">
                    <span class="button is-static">
                        Display voor handrub 1 liter
                    </span>
                </p>
            </div>
        </div>
    </div>

    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label"></label>
        </div>
        <div class="field-body">
            <div class="field has-addons">
                <p class="control">
                    <span class="button price" disabled="disabled">€{getUnitPrice($maskStore)}/stuk</span>
                </p>
                <p class="control">
                    <input class="input mobile-small"
                           type="number"
                           placeholder="Aantal"
                           bind:value={numberOfMasks}
                           use:maskCalculate={numberOfMasks}>
                </p>
                <p class="control">
                    <span class="button is-static">
                        50x chirurgisch mondmasker
                    </span>
                </p>
            </div>
        </div>
    </div>

    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label has-text-weight-medium">Totaal</label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="field has-addons">
                    <p class="control" class:is-danger={!$totalValidity.valid && $totalValidity.dirty}>
                        <input class="input"
                               type="number"
                               disabled="disabled"
                               use:totalValidate={$total}
                               class:is-danger={!$totalValidity.valid && $totalValidity.dirty}
                               value={$total}>
                    </p>
                    <p class="control">
                        <span class="button is-static">€</span>
                    </p>
                    <p class="control">
                        <span class="button" disabled="disabled">Exclusief BTW</span>
                    </p>
                </div>
                <p class="help" class:is-danger={!$totalValidity.valid && $totalValidity.dirty}>Minimum bestelbedrag:
                    €250</p>
            </div>
        </div>
    </div>

    <div class="field is-grouped">
        <div class="control">
            <button on:click={submitForm} class="submit button is-link">
                <span class="btn-text show">Bestelling plaatsen</span>
                <span class="btn-spinner hide lds-dual-ring"></span>
            </button>
        </div>
    </div>
</form>

<div class="spacer"></div>

<section class="sec">
    <div>
        <p>
            Levertermijn: maximum 2 weken
        </p>
        <p>
            Betaalvoorwaarden: 15 dagen na levering & ontvangst digitale factuur
        </p>
    </div>
</section>

<section class="section">
    <div class="columns">
        <div class="column is-half">
            <p>
                Deze site maakt gebruik van cookies om uw gebruikservaring te verbeteren.
            </p>
            <p>
                Door een bestelling te plaatsen geeft u toestemming om uw gegevens te verwerken. Deze worden enkel
                gebruikt voor het correct kunnen afhandelen van de bestelling.
            </p>
        </div>
    </div>
</section>

<section class="section">
    <p>Bijkomende vragen? Contacteer ons via
        <a href="mailto:safe-at-work@smidt-imex.com">safe-at-work@smidt-imex.com</a>.</p>
</section>